import { css } from '@emotion/react';
import { ReactNode } from 'react';

export const Heading = ({
	left,
	center,
	right,
}: {
	left?: ReactNode;
	center?: ReactNode;
	right?: ReactNode;
}) => {
	return (
		<div
			css={css`
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 20px 0;
			`}
		>
			<div>{left}</div>
			{!!center && <div>{center}</div>}
			<div>{right}</div>
		</div>
	);
};
